import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import {Row, Col} from 'react-flexbox-grid'
import Menu from 'react-burger-menu/lib/menus/slide'
import config from '../../config'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  MenuConfig,
  IyvBanner
} from '../../components'
import Styles from './HeaderMenu.css'


@CSSModules(Styles, {allowMultiple:true})
export default class HeaderMenu extends Component {
  constructor(props){
    super(props)
    const titleWords = config.app.title.split(' ')
    const firstTwoTitleWords = titleWords.slice(0,2).join(' ')
    this.state = {
      menuOpen: false,
      firstTwoTitleWords,
      lastTitleWord: titleWords[2]
    }
  }
  //
  clickMenu = () =>{
    this.setState({menuOpen: !this.state.menuOpen})
  }
  //
  render() {
    const styles = {
      bmBurgerButton: {
        position: 'relative',
        // width: '1.25rem',
        // height: '1.1rem',
        // float: 'right',
        zIndex: 'auto',
        float: 'left',
        cursor: 'pointer'
      },
      bmBurgerBars: {
        background: '#333',
        cursor: 'pointer'
      },
      bmIcon: {
        whiteSpace: 'nowrap',
        fontSize: '1.5em',
        fontFamily: "Montserrat,'Helvetica Neue',Arial,sans-serif",
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      bmMenuWrap: {
        top: 0,
        zIndex: 10001,
        width: '80%',
        maxWidth: '80%',
        left: '0px'
      },
      bmCrossButton: {
        height: '1.6rem',
        width: '1.6rem',
        cursor: 'pointer'
      },
      bmCross: {
        background: '#333',
        cursor: 'pointer'
      },
      bmMenu: {
        background: 'white',
        padding: '0 2.5rem 0 0',
        fontSize: '1.15rem',
        top: 0,
        borderLeft: '1px solid #A3A3A3'
      },
      bmMorphShape: {
        fill: 'white'
      },
      bmItemList: {
        color: '#333',
        padding: '0 1rem 1rem 1rem',
        boxSizing: 'border-box'
      },
      bmOverlay: {
        background: 'rgba(0, 0, 0, 0.76)',
        top: 0,
        right: 0,
        zIndex: 10000,
      }
    }
    //
    const link2 = config.app.title === 'Invest Your Values' ?
      [config.links.fff, 'Fossil Free Funds'] :
      [config.links.iyv, 'Invest Your Values']
    //
    return (
      <div styleName='header-container-wrap'>
        <ContainerDivs>

          <div styleName='header-row'>

            <div styleName='c'>
              <div styleName='block-link first-block-link h5'>
                <Link
                  to={config.links.ays}
                  title='As You Sow'
                >
                  As You Sow
                </Link>
              </div>
              <div styleName='block-link h5'>
                <Link
                  to={link2[0]}
                  title={link2[1]}
                >
                  {link2[1]}
                </Link>
              </div>
            </div>

            <div styleName='c'>
              <div styleName='block-link h5'>
                <Link
                  to={config.links.signup}
                  title='Sign up for email updates'
                >
                  Sign up
                </Link>
              </div>
              <div styleName='block-link donate h5'>
                <Link
                  to={config.links.donate}
                  title='Donate to As You Sow'
                >
                  Donate
                </Link>
              </div>
            </div>

          </div>

          <div styleName='header-row'>

            <div styleName='c'>
              <div styleName='menu-wrap'>
                <Menu
                  styles={styles}
                  isOpen={this.state.menuOpen}
                  burgerButtonClassName=''
                  customBurgerIcon={
                    <span style={{
                      'zIndex':'1'
                    }}>
                      <div>
                        <i className='fa fa-bars'/>
                      </div>
                    </span>
                  }
                >
                  <nav>
                    <Row>
                      <Col xs={12} sm={12} md={1} lg={2} />
                      {
                        MenuConfig.map((col, colI) => {
                          return <Col xs={12} sm={12} md={3} lg={3}
                            key={'menu-col-'+colI}
                            styleName='menu-column'
                          >
                            {
                              col.map((item, itemI)=>{
                                return <div
                                  key={'menu-item-'+itemI}
                                  styleName={'menu-link-'+item[2]}
                                >
                                  <Link
                                    to={item[0]}
                                    title={item[1]}
                                  >
                                    {
                                      item[3] ?
                                        <span>
                                          <LinkIcon
                                            nospace
                                            faclass={'fa-'+item[3]}
                                          />
                                          &nbsp;
                                        </span> :
                                        null
                                    }{item[1]}
                                    {
                                      item[4] ?
                                        <span styleName='menu-subtitle'>
                                          {item[4]}
                                        </span> :
                                        null
                                    }
                                  </Link>
                                </div>
                              })
                            }
                          </Col>
                        })
                      }
                    </Row>
                  </nav>
                  <IyvBanner hideTagline hideLink />
                </Menu>
              </div>

              <div styleName='header-title'>
                <Link
                  to='/'
                  title={config.app.title}
                >
                  <span styleName='header-title-nowrap'>
                    <span styleName='header-strong'>
                      {this.state.firstTwoTitleWords}
                    </span>
                    &nbsp;
                    <span styleName='header-mid'>
                      {this.state.lastTitleWord}
                    </span>
                  </span>
                </Link>
              </div>
            </div>

            <div styleName='c'>
              <div styleName='block-link last-block-link h4'>
                <Link
                  to={config.routes.clean}
                  title='Search funds'
                >
                  <LinkIcon nospace faclass='fa-search'/>&nbsp;Search
                </Link>
              </div>
            </div>

          </div>

        </ContainerDivs>
      </div>
    )
  }
}
